module.exports = __webpack_public_path__ + "img/3.b9e3c16.jpg";